import FlumpButton from "../../general/objects/FlumpButton";

export default class TitleButton extends FlumpButton
{
    constructor(game, config, library)
    {
        super(game, config, library);
    }

    _onInputUp()
    {
        super._onInputUp();
        this.inputEnabled = false;
        this.loop(this.keys.selected);
    }
}
